// We need to make sure to avoid importing anything
// depending on react-dnd@5 here unless the host app
// provides it.

export const PlaceholderContainerCompat = $hasDep('react-dnd', '5') ?
// eslint-disable-next-line @typescript-eslint/no-var-requires
require('../../adapters/hooks/PlaceholderContainer').PlaceholderContainer :
// eslint-disable-next-line @typescript-eslint/no-var-requires
require('../../adapters/hocs/PlaceholderContainer').PlaceholderContainer;